import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';

/**
 * Serviço Admin - Dashboard, Users, Entities, Plans, Reviews, Pets, Schedules
 */
export const adminService = {
  // ==================== DASHBOARD ====================
  async getDashboard() {
    const response = await api.get(ENDPOINTS.ADMIN_DASHBOARD);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  // ==================== USERS ====================
  async getUsers(params = {}) {
    const response = await api.get(ENDPOINTS.ADMIN_USERS, { params });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getUserDetail(id) {
    const response = await api.get(ENDPOINTS.ADMIN_USER_DETAIL(id));
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async updateUserStatus(id, active) {
    const response = await api.put(ENDPOINTS.ADMIN_USER_STATUS(id), { active });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  // ==================== ENTITIES ====================
  async getEntities(params = {}) {
    const response = await api.get(ENDPOINTS.ADMIN_ENTITIES, { params });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getEntitiesStats() {
    const response = await api.get(ENDPOINTS.ADMIN_ENTITIES_STATS);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getEntityDetail(id) {
    const response = await api.get(ENDPOINTS.ADMIN_ENTITY_DETAIL(id));
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async updateEntityStatus(id, active) {
    const response = await api.put(ENDPOINTS.ADMIN_ENTITY_STATUS(id), { active });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  // ==================== PLANS ====================
  async getPlans(params = {}) {
    const response = await api.get(ENDPOINTS.ADMIN_PLANS, { params });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getPlansStats() {
    const response = await api.get(ENDPOINTS.ADMIN_PLANS_STATS);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  // ==================== REVIEWS ====================
  async getReviews(params = {}) {
    const response = await api.get(ENDPOINTS.ADMIN_REVIEWS, { params });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getReviewsStats() {
    const response = await api.get(ENDPOINTS.ADMIN_REVIEWS_STATS);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  // ==================== PETS ====================
  async getPetsStats() {
    const response = await api.get(ENDPOINTS.ADMIN_PETS_STATS);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getPetsHealthAlerts() {
    const response = await api.get(ENDPOINTS.ADMIN_PETS_HEALTH_ALERTS);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  // ==================== SCHEDULES ====================
  async getSchedules(params = {}) {
    const response = await api.get(ENDPOINTS.ADMIN_SCHEDULES, { params });
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },

  async getSchedulesStats() {
    const response = await api.get(ENDPOINTS.ADMIN_SCHEDULES_STATS);
    if (response.data.error) throw new Error(response.data.response);
    return response.data.response;
  },
};
